import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./slices/authSlice";
import siteReducer from "./slices/siteSlice";
import locationReducer from "./slices/locationSlice";
import invitationReducer from "./slices/invitationSlice";
import globalAttributesReducer from "./slices/globalAttributesSlice";
import organizationReducer from "./slices/organizationSlice";
import siteMemberReducer from "./slices/siteMemberSlice";
import assetReducer from "./slices/assetSlice";
import departmentReducer from "./slices/departmentSlice";
import peopleReducer from "./slices/peopleSlice";
import insightReducer from "./slices/insightSlice";
import chatReducer from "./slices/chatSlice";

const sitePersistConfig = {
  key: "site",
  storage,
  whitelist: ["currentSite", "selectedOrganizationId"],
};

const assetPersistConfig = {
  key: "asset",
  storage,
  whitelist: ["currentAsset", "currentSite", "selectedSiteId"],
};

const persistedSiteReducer = persistReducer(sitePersistConfig, siteReducer);
const persistedAssetReducer = persistReducer(assetPersistConfig, assetReducer);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    site: persistedSiteReducer,
    location: locationReducer,
    invitation: invitationReducer,
    globalAttributes: globalAttributesReducer,
    organization: organizationReducer,
    siteMember: siteMemberReducer,
    asset: persistedAssetReducer,
    department: departmentReducer,
    people: peopleReducer,
    insight: insightReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
